<template>
<!-- eslint-disable max-len -->
<div
  class="settings-modal animated fadeIn"
  :class="{
    fadeOut: closing,
  }"
>
  <div style="display: flex; flex-flow: row nowrap; justify-content: space-between; align-items: flex-start;">
    <h2>
      Audio Settings
    </h2>
    <a href="" @click.prevent="close" class="btn btn-sm" style="font-size: 1.5rem;">
      &times;
    </a>
  </div>

  <div class="settings-form">
    <checkbox-input
      v-model="me.muteVoices"
    >Mute Voices</checkbox-input>
    <div
      v-if="!(me.muteVoices)"
      class="labeled-volume-slider"
    >
      <label
        for="voice-volume-slider"
      >Voices Volume</label>
      <input
        id="voice-volume-slider"
        class="volume-slider"
        type="range"
        :min="-100"
        :max="0"
        :step="1"
        v-model="me.volumeVoices"
      />
    </div>
    <checkbox-input
      v-model="me.muteSFX"
    >Mute SFX</checkbox-input>
    <div
      v-if="!(me.muteSFX)"
      class="labeled-volume-slider"
    >
      <label
        for="sfx-volume-slider"
      >SFX Volume</label>
      <input
        id="sfx-volume-slider"
        class="volume-slider"
        type="range"
        :min="-100"
        :max="0"
        :step="1"
        v-model="me.volumeSFX"
      />
    </div>
    <checkbox-input
      v-model="me.muteMusic"
    >Mute Music</checkbox-input>
    <div
      v-if="!(me.muteMusic)"
      class="labeled-volume-slider"
    >
      <label
        for="music-volume-slider"
      >Music Volume</label>
      <input
        id="music-volume-slider"
        class="volume-slider"
        type="range"
        :min="-100"
        :max="0"
        :step="1"
        v-model="me.volumeMusic"
      />
    </div>
  </div>

  <div style="display: flex; flex-flow: row nowrap; justify-content: space-between; align-items: flex-end;">
    <button
      class="btn"
      @click.prevent.once="close"
    >Close</button>
    <button
      class="btn"
      @click.prevent.once="update"
    >Save Settings</button>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import CheckboxInput from '../inputs/CheckboxInput';

export default {
  components: {
    CheckboxInput,
  },
  data() {
    return {
      closing: false,
    };
  },
  computed: {
    ...mapGetters([
      'me'
    ])
  },
  methods: {
    ...mapActions([
      'updateMe',
    ]),
    async update() {
      await this.updateMe(this.me);
      this.closing = true;
      await new Promise(resolve => setTimeout(resolve, 500));
      this.$emit('close');
    },
    async close() {
      this.closing = true;
      await new Promise(resolve => setTimeout(resolve, 500));
      this.$emit('close');
    }
  },
  mounted() {
    this.closing = false;
  },
  created() {
    if (this.me.muteVoices === undefined) this.me.muteVoices = false;
    if (this.me.volumeVoices === undefined) this.me.volumeVoices = 0;
    if (this.me.muteSFX === undefined) this.me.muteSFX = false;
    if (this.me.volumeSFX === undefined) this.me.volumeSFX = 0;
    if (this.me.muteMusic === undefined) this.me.muteMusic = false;
    if (this.me.volumeMusic === undefined) this.me.volumeMusic = 0;
  }
};
</script>

<style lang="scss" scoped>
.settings-modal {
  // background-color: rgba(0, 0, 7, 0.76);
  // color: white;
  background-color: var(--navBarColor);
  color: var(--navBarTextColor);
  padding: 15px;
  transition: all .15s linear;
  position: absolute;
  width: 400px;
  min-height: 60%;
  max-height: 90%;
  top: 40px;
  left: calc(50% - 200px);
  z-index: 1000;
  display: flex;
  flex-flow: column nowrap;
}
.settings-form {
  overflow: auto;
  flex-basis: calc(60% - 200px);
  flex-grow: 10;
  width: 100%;
  margin-bottom: 10px;
  padding: 0 4px;
}
.labeled-volume-slider {
  display: flex;
  flex-flow: column nowrap;
  margin-bottom: 20px;
}
.volume-slider {
  background-color: lightgrey;
  accent-color: var(--buttonColor);
}
</style>



// WEBPACK FOOTER //
// src/components/ui/modals/GameSettings.vue